import { cssVar } from './cssVar'

export const motionDelayVarTokens = {
  rail: cssVar('--app-motion-delay-rail'),
  shell: cssVar('--app-motion-delay-shell'),
  homeHero: cssVar('--app-motion-delay-home-hero'),
  briefing: cssVar('--app-motion-delay-briefing'),
  inputPanel: cssVar('--app-motion-delay-input-panel'),
  usageBlock: cssVar('--app-motion-delay-usage-block'),
  railPanelInner: cssVar('--app-motion-delay-rail-panel-inner'),
}

export const motionStaggerVarTokens = {
  sm: cssVar('--app-motion-stagger-sm'),
  usageChipBase: cssVar('--app-motion-stagger-usage-chip-base'),
}

export const motionNudgeVarTokens = {
  xs: cssVar('--app-motion-nudge-xs'),
  sm: cssVar('--app-motion-nudge-sm'),
  md: cssVar('--app-motion-nudge-md'),
}
